export const PERMISSION_TYPE = {
    ALLOW_ANY: 'ALLOW_ANY',
    AUTHORIZED_ONLY: 'AUTHORIZED_ONLY',
    ANONYMOUS_ONLY: 'ANONYMOUS_ONLY'
}